import { render } from "./CalHeatMaps.vue?vue&type=template&id=040e9680"
import script from "./CalHeatMaps.vue?vue&type=script&lang=js"
export * from "./CalHeatMaps.vue?vue&type=script&lang=js"

import "./CalHeatMaps.vue?vue&type=style&index=0&id=040e9680&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__